import { applyMiddleware, combineReducers, createStore } from 'redux';
import { thunk } from 'redux-thunk';

import auth from './auth';
import steps from './steps';
import menus from './menus';
import allergy from './allergy';
import blog from './blog';
import product from './product';
import popup from './popup';
import preloader from './preloader';

const USER_LOGOUT = 'USER_LOGOUT';

const allReducers = combineReducers({
  auth,
  steps,
  allergy,
  blog,
  product,
  preloader,
  menus,
  popup,
});

const rootReducer = (state, action) => {
  if (action.type === USER_LOGOUT) {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
    state = undefined;
  }

  return allReducers(state, action);
};

let middleware = [thunk];

export default createStore(rootReducer, applyMiddleware(...middleware));
